export default function applyPermissionsOverride(scopes, permissionsOverride) {
  return {
    canFilterByTeamsOrUsers: scopes.canFilterByTeamsOrUsers,
    canViewAllAssets: permissionsOverride && 'canViewAllAssets' in permissionsOverride ? permissionsOverride.canViewAllAssets : scopes.canViewAllAssets,
    canViewTeamOwnedAssets: permissionsOverride && 'canViewTeamOwnedAssets' in permissionsOverride ? permissionsOverride.canViewTeamOwnedAssets : scopes.canViewTeamOwnedAssets
  };
}